<template>
  <iframe
    id="mainiframe"
    :src="compileUrl"
    class="eqc-dialog-pay"
    frameborder="0"
    :height="height"
    scrolling="no"></iframe>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    close: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      height: 600
    }
  },
  computed: {
    compileUrl () {
      return `${this.data.url}`
    }
  },
  mounted () {
    window.addEventListener('message', this.onMessage)
  },
  destroyed () {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    onMessage (e) {
      if (typeof e.data !== 'string') return
      try {
        const data = JSON.parse(e.data)
        if (data.msgType === 'success') {
          this.close(data)
        } else if (data.msgType === 'close') {
          this.close(data)
        } else if (data.msgType === 'load') {
          this.height = data.data.height
        } else {
          this.close(data)
        }
      } catch (err) {
        this.$message.error(err)
      }
    }
  }
}
</script>

<style lang="scss">
.eqc-dialog-pay {
  position: absolute;
  width: 100%;
  height:100%;
  transition: all 0.3s;
}
</style>
